export default __webpack_public_path__ + "data/okeeffe-livedplaces-dates.csv";